<template>
  <component
    :is="navbarcomponent"
    :help-active="helpActive"
  />
</template>

<script>
export default {
  name: 'page-top',
  asyncComponents: (app) => {
    let version = app.store.getters['getModuleSetting']('theme', 'page-navbar', '0001')
    return [
      `page-navbar-${version}`
    ]
  },
  props: {
    'helpActive': {
      default: false,
      type: Boolean,
      required: false
    }
  },
  computed: {
    navbarcomponent: function() {
      const version = this.$store.getters['getModuleSetting']('theme', 'page-navbar', '0001')
      return `page-navbar-${version}`
    }
  }
}
</script>
